import './Resume.styles.css';

const Resume = () => {
  return(
    <div className="resume">
      <a title="Download Resume" className="btn btn-outline-light btn-lg" href="/resume-pedro-gutierrez.pdf" target="_blank">Download Resume</a>
    </div>
  )
};

export default Resume;
